import {
  LOAD_APP,
} from '../actions';

const initialState = {
  loaded: false,
};

export default function app(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_APP.SUCCESS: {
      return {...state, loaded: true};
    }
    case LOAD_APP.FAILURE: {
      return {...state, loaded: false};
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/app.js